import iconTemplate from './IconTemplate.jsx';

export default iconTemplate(
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 14 14"
        id="Heading-2-Paragraph-Styles-Heading--Streamline-Flex"
    >
        <desc>
            {
                'Heading 2 Paragraph Styles Heading Streamline Icon: https://streamlinehq.com'
            }
        </desc>
        <g id="heading-2-paragraph-styles-heading">
            <path
                id="Vector 4"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M13.5001 12.501h-2.6983c0 -1.4978 0.8376 -1.7101 2.1077 -2.3029 0.3588 -0.1674 0.5906 -0.54546 0.5906 -0.96316 0 -0.58064 -0.4413 -1.05135 -0.9856 -1.05135h-0.7009c-0.4405 0 -0.8154 0.30035 -0.9543 0.71957"
                strokeWidth={1}
            />
            <path
                id="Vector 1"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M0.5 12.501V1.50098m7 0V12.501m-7 -5.95836c2.35186 -0.28937 4.64814 -0.28937 7 0"
                strokeWidth={1}
            />
        </g>
    </svg>,
);
